import axiosInstance from "../axios/axiosInstance";
import config from "./Config";

export default class ProfileService {

    postProfile(data, profile) {
        return axiosInstance.post(`${config.api.version}/profile/${data}/`, profile)
    }

    putProfile(data, id, profile) {
        return axiosInstance.put(`${config.api.version}/profile/${data}/${id}`, profile)
    }

    getProfileById(id) {
        return axiosInstance.get(`${config.api.version}/profile/${id}/get/${id}`);
    }

}
